// Copyright (c) 2016 Deere & Company

import DateCellRenderer from '../../shared/report-cell-renderers/date-cell-renderer';
import PinCellRenderer from '../../shared/report-cell-renderers/pin-cell-renderer';
import classNames from '../../shared/constants/ag-grid-class-names';
import dateFilterParams from '../../shared/constants/date-filter-params';
import {translate} from '../../../shared/services/translation-service';

export function getDemoRentalHistoryColumnDefinitions() {

    return [
        {
            cellClass: classNames.cellLeftClassName,
            cellRendererFramework: PinCellRenderer,
            colId: 'pin',
            field: 'pin',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('PIN'),
            width: 190
        },
        {
            cellClass: classNames.cellClassName,
            colId: 'status',
            field: 'status',
            headerClass: classNames.headerClassName,
            headerName: translate('STATUS'),
            width: 100
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'comments',
            field: 'comments',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('COMMENTS'),
            hide: true,
            width: 300

        },
        {
            cellClass: classNames.cellClassName,
            colId: 'dealerAccount',
            field: 'dealerAccount',
            headerClass: classNames.headerClassName,
            headerName: translate('ACCOUNT'),
            width: 100

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerName',
            field: 'dealerName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('DEALER'),
            width: 200
        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'dealerCity',
            field: 'dealerCity',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('LOCATION'),
            width: 200

        },
        {
            cellClass: classNames.cellLeftClassName,
            colId: 'tcsmName',
            field: 'tcsmName',
            headerClass: classNames.headerLeftClassName,
            headerName: translate('TCSM'),
            width: 200

        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'beginDate',
            field: 'beginDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('BEGIN_DATE'),
            width: 120

        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'endDate',
            field: 'endDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('END_DATE'),
            width: 120
        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'daysOnDemoOrRent',
            field: 'daysOnDemoOrRent',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('DAYS_ON_RENT'),
            width: 120

        },
        {
            cellClass: classNames.cellRightClassName,
            colId: 'hoursOnDemoOrRent',
            field: 'hoursOnDemoOrRent',
            filter: 'number',
            headerClass: classNames.headerRightClassName,
            headerName: translate('HOURS_ON_RENT'),
            width: 180
        },
        {
            cellClass: classNames.cellClassName,
            cellRendererFramework: DateCellRenderer,
            colId: 'registrationDate',
            field: 'registrationDate',
            filter: 'date',
            filterParams: dateFilterParams,
            headerClass: classNames.headerClassName,
            headerName: translate('REGISTERED'),
            width: 120
        }
    ];

}



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/report-services/column-definitions.js